import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';

class RejectDialog extends React.Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
  };
  handleApprove = () => {
    this.props.handleApprove();
  };

  render() {
    const { fullScreen,cancelReason } = this.props;

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={this.props.open}
          onClose={this.handleClose}
        >
          <DialogTitle id="responsive-dialog-title"><h4>Süreç Reddedilecek</h4></DialogTitle>
          <DialogContent>
            <DialogContentText>
              <h4>Süreci reddetmek istediğinize emin misiniz?</h4>
            </DialogContentText>
            <InputLabel id="cancelReasonLbl">Red Sebebiniz</InputLabel>
            <TextField style={{ width: '95%'}} multiline rows={4} labelId="cancelReasonLbl" id="cancelReasonText" name="cancelReason" value={cancelReason} variant="outlined" onChange={this.props.handleChange}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              İptal
            </Button>
            <Button onClick={this.handleApprove} color="primary" autoFocus>
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

RejectDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(RejectDialog);
